import { autoinject } from "aurelia-dependency-injection";
import { AttachmentViewerDocument, AttachmentViewerNewTab  } from "../../../../models/attachment/attachment.models";
import { CacheClientService, CacheLocation } from "@rightship-tech/common-ui/services/basic/client-caching.service";
import { useView } from "aurelia-framework";

@autoinject
@useView('views/pages/attachment-viewer-client/pages/attachment-viewer.html')
export class AttachmentViewer {

    public entityId: number;
    public entityTypeId: number;
    public getAttachmentDocuments: (() => Promise<AttachmentViewerDocument[]>);
    private _newTabIdentifier: string;

    constructor(public cacheService: CacheClientService) {
    }
    
    async activate(params: { entityTypeId: string, id: string, openInNewTab: string }) {
        if (params.openInNewTab && params.openInNewTab == "true") {
            this._newTabIdentifier = params.id;
            const cachedItem = await this.cacheService.get<AttachmentViewerNewTab>(`attachmentResults-${this._newTabIdentifier}`, CacheLocation.LocalStorage, false);
            if (cachedItem) {
                this.getAttachmentDocuments = (): Promise<AttachmentViewerDocument[]> => {
                    return new Promise((resolve) => {
                        resolve(cachedItem?.documents);
                    });
                }
            }
        } else {
            this.entityId = Number(params.id);
            this.entityTypeId = Number(params.entityTypeId);
        }
    }

    detached() {
        setTimeout(() => {
            this.cacheService.remove(`attachmentResults-${this._newTabIdentifier}`);
        }, 5000);
    }
}
